export const SET = '/ReleaseVehicleFromHold/set';
